export default [
  {
    path: '/admin/defines/purchase-offer-config',
    name: 'PurchaseOfferConfig',
    component: () => import('@/views/Admin/Defines/PurchaseOfferConfig/Index.vue'),
    meta: {
      pageTitle: 'Satınalma Teklif Tanımları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/purchase-offer-config/add',
    name: 'PurchaseOfferConfigAdd',
    component: () => import('@/views/Admin/Defines/PurchaseOfferConfig/Add.vue'),
    meta: {
      pageTitle: 'Satınalma Teklif Tanımları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/purchase-offer-config',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/purchase-offer-config/edit/:id',
    name: 'PurchaseOfferConfigEdit',
    component: () => import('@/views/Admin/Defines/PurchaseOfferConfig/Edit.vue'),
    meta: {
      pageTitle: 'Satınalma Teklif Tanımları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/purchase-offer-config',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
